import React from 'react'
import { Field } from 'redux-form'

import { Input } from '../../../components/Input/Input'
import Button from '../../../components/Button/Button'
import { vEmail, vNotEmpty, vStandardNumber } from '../../../components/Input/Input.validations'
import cn from 'classnames'

import sLay from 'styles/modules/layout.scss'

export default props => {
  const { numberType, invalid, prev } = props

  return (
    <div>
      <Field
        name="callForwardingNumber"
        label="Call Forwarding Number"
        component={Input}
        validate={[vStandardNumber, vNotEmpty]}
        info="All incoming calls will be forwarded to this number"
      />

      <br />
      <br />

      {numberType === 'mobile' ? (
        <Field
          name="smsForwardingEmail"
          label="SMS Forwarding Email"
          component={Input}
          validate={[vEmail, vNotEmpty]}
          info="All incoming SMS will be forwarded to this email"
        />
      ) : null}

      <div
        className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
        style={{ marginTop: '40px' }}
      >
        <Button color="tertiary" type="submit" disabled={invalid}>
          Next
        </Button>
        <br />
        <br />
        <Button plain onClick={prev}>
          Back
        </Button>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersTwilioDefaultFlowsConfigStep/NumbersTwilioDefaultFlowsConfigStep.jsx